import { render, staticRenderFns } from "./samplingDetails.vue?vue&type=template&id=a5da7bda"
import script from "./samplingDetails.vue?vue&type=script&lang=js"
export * from "./samplingDetails.vue?vue&type=script&lang=js"
import style0 from "./samplingDetails.vue?vue&type=style&index=0&id=a5da7bda&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports